<template>
  <v-container id="master-flyer" fluid tag="section" class="cyber-container">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-image-multiple-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-title">
              MODUL FLYER PUBLIKASI
            </div>
            <div class="subtitle-1 font-weight-light secondary-text">
              Manajemen Media Informasi & Flyer Kreatif
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="6">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-box-outline</v-icon> TAMBAH FLYER BARU
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-database-search"
                  label="Cari Berdasarkan Deskripsi..."
                  single-line
                  hide-details
                  flat
                  solo-inverted
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filteredFlyer"
              :loading="loading"
              class="transparent-table"
            >
              <template v-slot:item.foto="{ item }">
                <div class="table-photo-frame">
                  <v-img
                    :src="renderImage(item.foto)"
                    aspect-ratio="1.3"
                    width="70"
                    height="50"
                    cover
                    class="rounded-sm border-accent"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-icon color="#018C74">mdi-loading mdi-spin</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </template>

              <template v-slot:item.is_active="{ item }">
                <v-chip
                  x-small
                  outlined
                  :color="item.is_active == 1 ? '#018C74' : '#ff5252'"
                >
                  {{ item.is_active == 1 ? "AKTIF" : "NON-AKTIF" }}
                </v-chip>
              </template>

              <template v-slot:item.deskripsi="{ item }">
                <span class="white--text plain-description">{{ item.deskripsi }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="#018C74"
                  @click="openDialog(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="#ff5252"
                  @click="deleteItem(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-delete-variant</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px" persistent overlay-opacity="0.85">
      <v-card class="cyber-dialog">
        <v-card-title class="dialog-header">
          <v-icon left color="#CFA22D">mdi-form-select</v-icon>
          <span class="font-weight-bold white--text">{{ formTitle.toUpperCase() }}</span>
          <v-spacer />
          <v-btn icon @click="close" small ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-8 px-6">
          <v-switch
            v-model="editedItem.is_active"
            :label="`STATUS PUBLIKASI: ${
              editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'
            }`"
            :true-value="1"
            :false-value="0"
            color="#018C74"
            inset
          ></v-switch>

          <v-textarea
            v-model="editedItem.deskripsi"
            label="Deskripsi Flyer"
            outlined
            color="#018C74"
            rows="4"
            class="cyber-input"
          />

          <v-file-input
            v-model="imageFile"
            label="Unggah Materi Flyer (Gambar)"
            accept="image/*"
            prepend-icon=""
            prepend-inner-icon="mdi-camera-plus-outline"
            outlined
            color="#018C74"
            @change="previewImage"
            class="cyber-input"
          />

          <v-expand-transition>
            <div v-if="imageUrl" class="d-flex justify-center my-4">
              <div class="preview-scanner">
                <div class="scan-bar"></div>
                <v-img
                  :src="imageUrl"
                  max-height="220"
                  contain
                  class="rounded border-glow"
                />
              </div>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-btn text @click="close" class="white--text opacity-6">BATAL</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="cyber-btn-save" :loading="loading" @click="save"
            >SIMPAN DATA</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    flyerList: [],
    imageFile: null,
    imageUrl: null,
    headers: [
      { text: "VISUAL", value: "foto", width: "100px", sortable: false },
      { text: "DESKRIPSI FLYER", value: "deskripsi" },
      { text: "STATUS", value: "is_active", width: "120px" },
      { text: "AKSI", value: "actions", sortable: false, align: "end", width: "100px" },
    ],
    editedIndex: -1,
    editedItem: { id: null, deskripsi: "", foto: "", is_active: 1 },
    defaultItem: { id: null, deskripsi: "", foto: "", is_active: 1 },
  }),

  computed: {
    filteredFlyer() {
      let list = this.flyerList;
      if (this.search) {
        const query = this.search.toLowerCase();
        list = list.filter(
          (item) => item.deskripsi && item.deskripsi.toLowerCase().includes(query)
        );
      }
      return list;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Tambah Flyer" : "Edit Flyer";
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/flyer`);
        if (res.data && res.data.response) {
          this.flyerList = res.data.response.data;
        }
      } catch (e) {
        console.error("Gagal load data flyer:", e);
      } finally {
        this.loading = false;
      }
    },

    renderImage(filename) {
      if (!filename) return null;
      return encodeURI(`${BASE_URL}/uploads/${filename}`);
    },

    previewImage() {
      if (this.imageFile) {
        this.imageUrl = URL.createObjectURL(this.imageFile);
      } else {
        this.imageUrl =
          this.editedIndex > -1 ? this.renderImage(this.editedItem.foto) : null;
      }
    },

    openDialog(item) {
      this.editedIndex = item ? this.flyerList.indexOf(item) : -1;
      this.editedItem = item
        ? Object.assign({}, item)
        : Object.assign({}, this.defaultItem);
      this.imageUrl = item ? this.renderImage(item.foto) : null;
      this.imageFile = null;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.imageFile = null;
        this.imageUrl = null;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (!this.editedItem.deskripsi) {
        return alert("Deskripsi wajib diisi!");
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("deskripsi", this.editedItem.deskripsi);
        formData.append("is_active", this.editedItem.is_active);

        if (this.imageFile) formData.append("foto", this.imageFile);

        if (this.editedIndex > -1) {
          await axios.put(`${BASE_URL}/flyer/${this.editedItem.id}`, formData);
        } else {
          await axios.post(`${BASE_URL}/flyer`, formData);
        }

        this.fetchData();
        this.close();
      } catch (e) {
        alert("Gagal menyimpan data flyer");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus flyer ini?`)) {
        try {
          await axios.delete(`${BASE_URL}/flyer/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal menghapus flyer");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-container {
  background: transparent;
}
.cyber-title {
  letter-spacing: 3px !important;
  text-shadow: 0 0 12px rgba(1, 140, 116, 0.4);
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}
.opacity-6 {
  opacity: 0.6;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  color: #cfa22d !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-btn-add {
  background: linear-gradient(45deg, #018c74, #004d40) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
  box-shadow: 0 0 15px rgba(1, 140, 116, 0.3) !important;
}
.cyber-btn-save {
  background-color: #cfa22d !important;
  color: #002616 !important;
  font-weight: 900 !important;
}
.table-photo-frame {
  padding: 2px;
  border: 1px solid rgba(207, 162, 45, 0.3);
  display: inline-block;
}
.glow-hover:hover {
  filter: drop-shadow(0 0 5px currentColor);
}
.cyber-dialog {
  background: rgba(0, 20, 18, 0.96) !important;
  border: 1px solid #018c74 !important;
}
.dialog-header {
  border-bottom: 1px solid rgba(1, 140, 116, 0.3);
  background: rgba(1, 140, 116, 0.1);
}
.preview-scanner {
  position: relative;
  border: 2px solid #018c74;
  padding: 5px;
  background: #000;
  overflow: hidden;
}
.scan-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #cfa22d;
  box-shadow: 0 0 10px #cfa22d;
  animation: scanning 2.5s linear infinite;
  z-index: 2;
}
.plain-description {
  font-size: 14px;
  line-height: 1.4;
  display: block;
  max-width: 400px;
  white-space: pre-line;
}
@keyframes scanning {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
